import React from "react";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Chip, IconButton, Typography, Box, Tooltip } from "@mui/material";
import { Edit as EditIcon, Delete as DeleteIcon } from "@mui/icons-material";
import PermissionGuard from "../access-control/PermissionGuard";
import { RESOURCES, ACTIONS } from "../../hooks/usePermissions";
import { fDateDdMmmYyyy } from "../../utils/time";

const SubjectAllocationsTable = ({ allocations, onEdit, onDelete }) => {
  return (
    <TableContainer component={Paper} elevation={0} sx={{ overflowX: "auto" }}>
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell sx={{ minWidth: 150 }}>Teacher</TableCell>
            <TableCell sx={{ minWidth: 120 }}>Class</TableCell>
            <TableCell sx={{ minWidth: 100 }}>Stream</TableCell>
            <TableCell sx={{ minWidth: 150 }}>Subject</TableCell>
            <TableCell sx={{ minWidth: 120 }}>Paper</TableCell>
            <TableCell sx={{ minWidth: 100 }}>Year</TableCell>
            <TableCell sx={{ minWidth: 100 }}>Term</TableCell>
            <TableCell sx={{ minWidth: 100 }}>Type</TableCell>
            <TableCell sx={{ minWidth: 120 }}>Start Date</TableCell>
            <TableCell sx={{ minWidth: 120 }}>End Date</TableCell>
            <TableCell sx={{ minWidth: 80 }}>Status</TableCell>
            <TableCell sx={{ minWidth: 120 }}>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {allocations.length > 0 ? (
            allocations.map((allocation) => (
              <TableRow key={allocation.id} hover>
                <TableCell>
                  <Typography variant="body2" fontWeight="medium">{allocation.teacher?.full_name || "N/A"}</Typography>
                  <Typography variant="caption" color="text.secondary">{allocation.teacher?.staff_number}</Typography>
                </TableCell>
                <TableCell><Typography variant="body2">{allocation.class_stream_subject_paper?.class?.name || allocation.class_stream_subject_paper?.class?.class_name || "N/A"}</Typography></TableCell>
                <TableCell><Typography variant="body2">{allocation.class_stream_subject_paper?.stream?.stream_name || "-"}</Typography></TableCell>
                <TableCell><Typography variant="body2">{allocation.class_stream_subject_paper?.subject_paper?.subject?.subject_name || "N/A"}</Typography></TableCell>
                <TableCell><Typography variant="body2">{allocation.class_stream_subject_paper?.subject_paper?.paper_name || "N/A"}</Typography></TableCell>
                <TableCell><Typography variant="body2">{allocation.academic_year}</Typography></TableCell>
                <TableCell><Typography variant="body2">{allocation.term?.name || "-"}</Typography></TableCell>
                <TableCell><Chip label={allocation.is_primary ? "Primary" : "Assistant"} color={allocation.is_primary ? "primary" : "default"} size="small" /></TableCell>
                <TableCell><Typography variant="body2">{fDateDdMmmYyyy(allocation.start_date) || "N/A"}</Typography></TableCell>
                <TableCell><Typography variant="body2">{fDateDdMmmYyyy(allocation.end_date) || "Ongoing"}</Typography></TableCell>
                <TableCell><Chip label={allocation.is_active ? "Active" : "Inactive"} color={allocation.is_active ? "success" : "default"} size="small" /></TableCell>
                <TableCell>
                  <Box display="flex" gap={0.5}>
                    <Tooltip title="Edit Allocation">
                      <PermissionGuard resource={RESOURCES.USERS} action={ACTIONS.UPDATE}>
                        <IconButton size="small" color="primary" onClick={() => onEdit(allocation)}><EditIcon fontSize="small" /></IconButton>
                      </PermissionGuard>
                    </Tooltip>
                    <Tooltip title="Delete Allocation">
                      <PermissionGuard resource={RESOURCES.USERS} action={ACTIONS.DELETE}>
                        <IconButton size="small" color="error" onClick={() => onDelete(allocation.id)}><DeleteIcon fontSize="small" /></IconButton>
                      </PermissionGuard>
                    </Tooltip>
                  </Box>
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={12} align="center" sx={{ py: 4 }}><Typography variant="body2" color="text.secondary">No allocations found</Typography></TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default SubjectAllocationsTable;
